<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="budgets-container">
  @for (budget of filteredBudgets; track budget) {
    <div class="col-lg-4 col-md-6 budget-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">
              Proračun verzija broj {{ budget.budgetVersion }}
              @if (budget.budgetVersion === 1) {
                <span> - Inicijalni proračun</span>
              }
              @if (budget.budgetVersion > 1) {
                <span> - Prenamjena sredstava</span>
              }
            </h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>
            <strong>Izravni troškovi:</strong><br>
            Ukupan iznos tražen od Općine: {{ budget.totalDirectCostsRequested | currency:'EUR' }}<br>
            Ukupan iznos troška: {{ budget.totalDirectCostsActual | currency:'EUR' }}
          </p>
          <p>
            <strong>Neizravni troškovi:</strong><br>
            Ukupan iznos tražen od Općine: {{ budget.totalIndirectCostsRequested | currency:'EUR' }}<br>
            Ukupan iznos troška: {{ budget.totalIndirectCostsActual | currency:'EUR' }}
          </p>
          <p>
            <strong>Sveukupno:</strong><br>
            Ukupan iznos tražen od Općine: {{ budget.totalCostsRequested | currency:'EUR' }}<br>
            Ukupan iznos troška: {{ budget.totalCostsActual | currency:'EUR' }}
          </p>
          <p>
            <strong>Ostali izvori financiranja ukupno:</strong><br>
            {{ budget.totalFundingFromOtherSources | currency:'EUR' }}
          </p>
          <p>
            <strong>Sveukupni iznos troškova (svi izvori):</strong><br>
            {{ budget.totalFunding | currency:'EUR' }}
          </p>
          <p>
            <strong>Odobreni iznos projekta:</strong><br>
            {{ projectApprovedAmount | currency:'EUR' }}
          </p>
          <p>
            <strong>Usklađivanje:</strong>
            <span class="daxa-badge" [ngClass]="{ 'green': isBudgetSynced(budget), 'red': !isBudgetSynced(budget) }">
              {{ isBudgetSynced(budget) ? 'Proračun usklađen' : 'Proračun nije usklađen' }}
            </span>
          </p>
          <p>
            <strong>Status proračuna:</strong>
            <span class="daxa-badge" [ngClass]="{
              'blue': budget.status === ProjectBudgetStatus.Draft || budget.status === ProjectBudgetStatus.Returned,
              'yellow': budget.status === ProjectBudgetStatus.Submitted || budget.status === ProjectBudgetStatus.Resubmitted,
              'green': budget.status === ProjectBudgetStatus.Approved,
              'red': budget.status === ProjectBudgetStatus.Rejected
            }">
              {{ budget.userFriendlyStatus }}
            </span>
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj proračun" (click)="goToViewBudget(budget)">
            <mat-icon>visibility</mat-icon>
          </button>
          @if (budget.isActionAllowed('Edit')) {
            <button mat-icon-button color="primary" matTooltip="Uredi proračun" (click)="goToEditBudget(budget)">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (budget.isActionAllowed('Submit') && isBudgetSynced(budget)) {
            <button mat-icon-button color="primary" matTooltip="Predloži proračun Općini" (click)="confirmSubmit(budget)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          @if (budget.isActionAllowed('Resubmit') && isBudgetSynced(budget)) {
            <button mat-icon-button color="primary" matTooltip="Ponovno predloži proračun Općini" (click)="confirmResubmit(budget)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          @if (budget.isActionAllowed('CreateReallocation') && canCreateReallocation(budget)) {
            <button mat-icon-button color="primary" matTooltip="Kreiraj prenamjenu sredstava" (click)="confirmBudgetReallocation(budget)">
              <mat-icon>swap_horiz</mat-icon>
            </button>
          }
          <button mat-icon-button color="primary" matTooltip="Preuzmi obrazac proračuna" (click)="downloadBudget(budget)">
            <mat-icon>download</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
